






















import { computed, defineComponent, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "PixEditView",
  components: { BaseForm, BaseButton },
  props: {
    processing: { type: Boolean, required: true, default: false },
    qrUrl: { type: String, required: true },
  },
  setup(_, { emit }) {
    const show = ref(false);
    const valid = ref<boolean>(false);
    const validate = ref<() => Promise<void>>(async () => {});
    const values = ref<FormValues>({
      firstName: "",
      lastName: "",
    });

    const fields = computed<FormFields>(() => [
      {
        name: "firstName",
        label: $t("First name"),
        rules: ["required"],
      },
      {
        name: "lastName",
        label: $t("Last name"),
        rules: ["required"],
      },
    ]);

    const onFormInput = (v: FormValues) => {
      emit("input", v);
    };

    const onSubmit = () => {
      emit("submit", values.value);
    };

    return {
      show,
      fields,
      values,
      onSubmit,
      onFormInput,
      valid,
      validate,
    };
  },
});
